import React from 'react';
import { Layout } from 'antd';

const { Footer: AntdFooter } = Layout;

const Footer: React.FC = () => {
  return (
    <AntdFooter style={{ textAlign: 'center' }}>
      JadePay Copyright 2024
    </AntdFooter>
  );
};

export default Footer;